'use strict';

/**
 * Locale Switcher component.
 *
 * Renders a text-link facade over a hidden native <select>.
 * When the user picks a site the page navigates to that site's landing URL.
 */
function initLocaleSwitcher() {
    var select = document.getElementById('locale-select');
    if (!select) { return; }

    select.addEventListener('change', function () {
        var url = select.value;
        if (url) {
            window.location.href = url;
        }
    });
}

module.exports = { initLocaleSwitcher: initLocaleSwitcher };
